/*
  *******************
      注册全局组件
  *******************
*/
import Vue from 'vue'

import layout from '~/components/layout'
import layoutSidebar from '~/components/layout/sidebar'
import layoutContainer from '~/components/layout/container'
import layoutContainerHeader from '~/components/layout/container/header'
import layoutContainerMain from '~/components/layout/container/main'
import layoutOuter from '~/components/layout/outer'

// 布局组件
Vue.component('layout', layout)
Vue.component('layoutSidebar', layoutSidebar)
Vue.component('layoutContainer', layoutContainer)
Vue.component('layoutContainerHeader', layoutContainerHeader)
Vue.component('layoutContainerMain', layoutContainerMain)
Vue.component('layoutOuter', layoutOuter)



// WEBPACK FOOTER //
// ./src/utils/components.js